export class SeededRng {
  private stateValue: number;

  public constructor(seed: number) {
    this.stateValue = seed >>> 0 || 0x9e3779b9;
  }

  public get state(): number {
    return this.stateValue;
  }

  public nextUint32(): number {
    let value = this.stateValue;
    value ^= value << 13;
    value ^= value >>> 17;
    value ^= value << 5;
    this.stateValue = value >>> 0;
    return this.stateValue;
  }

  public next(): number {
    return this.nextUint32() / 0x1_0000_0000;
  }

  public integer(minimum: number, maximumExclusive: number): number {
    if (
      !Number.isInteger(minimum) ||
      !Number.isInteger(maximumExclusive) ||
      maximumExclusive <= minimum
    ) {
      throw new RangeError("Invalid deterministic integer range.");
    }
    return minimum + Math.floor(this.next() * (maximumExclusive - minimum));
  }

  public weighted(entries: readonly (readonly [string, number])[]): string {
    const total = entries.reduce(
      (sum, [, weight]) => sum + Math.max(0, weight),
      0,
    );
    if (total <= 0)
      throw new RangeError(
        "Weighted selection requires a positive total weight.",
      );
    let roll = this.next() * total;
    for (const [id, weight] of entries) {
      roll -= Math.max(0, weight);
      if (roll < 0) return id;
    }
    const fallback = entries[entries.length - 1];
    if (fallback === undefined)
      throw new RangeError("Weighted selection requires at least one entry.");
    return fallback[0];
  }
}
